import type { ShareSheetResult } from '../types/TareBridge';

import TypedNativeModules from '../internal/TypedNativeModules';

export async function openShareSheet(
    url: string,
    message: string,
    subject: string | null | undefined,
): Promise<ShareSheetResult> {
    const tareBridge = TypedNativeModules.RNTareBridge;
    if (!tareBridge?.openShareSheet) {
        return Promise.reject('openShareSheet not available');
    }
    return tareBridge.openShareSheet(url, message, subject);
}
